var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "comprehensive-table-container" },
    [
      _c(
        "vab-query-form",
        [
          _c(
            "vab-query-form-top-panel",
            [
              _c(
                "el-form",
                {
                  ref: "queryForm",
                  attrs: {
                    inline: true,
                    "label-width": "115px",
                    model: _vm.queryForm
                  },
                  nativeOn: {
                    submit: function($event) {
                      $event.preventDefault()
                    }
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "客户中文品名", prop: "cusProductCnName" }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "180px" },
                        attrs: { clearable: "", placeholder: "请输入" },
                        model: {
                          value: _vm.queryForm.cusProductCnName,
                          callback: function($$v) {
                            _vm.$set(_vm.queryForm, "cusProductCnName", $$v)
                          },
                          expression: "queryForm.cusProductCnName"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "客户英文品名", prop: "cusProductEnName" }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "180px" },
                        attrs: { clearable: "", placeholder: "请输入" },
                        model: {
                          value: _vm.queryForm.cusProductEnName,
                          callback: function($$v) {
                            _vm.$set(_vm.queryForm, "cusProductEnName", $$v)
                          },
                          expression: "queryForm.cusProductEnName"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "申报中文品名", prop: "reportCnName" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "180px" },
                        attrs: { clearable: "", placeholder: "请输入" },
                        model: {
                          value: _vm.queryForm.reportCnName,
                          callback: function($$v) {
                            _vm.$set(_vm.queryForm, "reportCnName", $$v)
                          },
                          expression: "queryForm.reportCnName"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "申报英文品名", prop: "reportEnName" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "180px" },
                        attrs: { clearable: "", placeholder: "请输入" },
                        model: {
                          value: _vm.queryForm.reportEnName,
                          callback: function($$v) {
                            _vm.$set(_vm.queryForm, "reportEnName", $$v)
                          },
                          expression: "queryForm.reportEnName"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "中国海关编码", prop: "hsCode" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "180px" },
                        attrs: { clearable: "", placeholder: "请输入" },
                        model: {
                          value: _vm.queryForm.hsCode,
                          callback: function($$v) {
                            _vm.$set(_vm.queryForm, "hsCode", $$v)
                          },
                          expression: "queryForm.hsCode"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "进口国海关编码", prop: "importHsCode" }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "180px" },
                        attrs: { clearable: "", placeholder: "请输入" },
                        model: {
                          value: _vm.queryForm.importHsCode,
                          callback: function($$v) {
                            _vm.$set(_vm.queryForm, "importHsCode", $$v)
                          },
                          expression: "queryForm.importHsCode"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.fold,
                          expression: "fold"
                        }
                      ],
                      attrs: { label: "关税税率", prop: "rateOfDuty" }
                    },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "180px" },
                        attrs: {
                          max: 100,
                          min: 0,
                          precision: 2,
                          size: "medium",
                          step: 0.1
                        },
                        model: {
                          value: _vm.queryForm.rateOfDuty,
                          callback: function($$v) {
                            _vm.$set(_vm.queryForm, "rateOfDuty", $$v)
                          },
                          expression: "queryForm.rateOfDuty"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.fold,
                          expression: "fold"
                        }
                      ],
                      attrs: { label: "风险评估", prop: "riskType" }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "180px" },
                          attrs: { clearable: "", placeholder: "请选择类型" },
                          model: {
                            value: _vm.queryForm.riskType,
                            callback: function($$v) {
                              _vm.$set(_vm.queryForm, "riskType", $$v)
                            },
                            expression: "queryForm.riskType"
                          }
                        },
                        _vm._l(_vm.riskTypeList, function(item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.fold,
                          expression: "fold"
                        }
                      ],
                      attrs: { label: "是否可承接", prop: "acceptability" }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "180px" },
                          attrs: { clearable: "", placeholder: "请选择类型" },
                          model: {
                            value: _vm.queryForm.acceptability,
                            callback: function($$v) {
                              _vm.$set(_vm.queryForm, "acceptability", $$v)
                            },
                            expression: "queryForm.acceptability"
                          }
                        },
                        _vm._l(_vm.acceptabilityList, function(item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.fold,
                          expression: "fold"
                        }
                      ],
                      attrs: { label: "包税附加费", prop: "surcharge" }
                    },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "180px" },
                        attrs: {
                          max: 100,
                          min: 0,
                          precision: 2,
                          size: "medium",
                          step: 0.1
                        },
                        model: {
                          value: _vm.queryForm.surcharge,
                          callback: function($$v) {
                            _vm.$set(_vm.queryForm, "surcharge", $$v)
                          },
                          expression: "queryForm.surcharge"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "text" },
                          on: { click: _vm.handleFold }
                        },
                        [
                          _vm.fold
                            ? _c("span", [_vm._v("合并")])
                            : _c("span", [_vm._v("展开")]),
                          _c("vab-icon", {
                            staticClass: "vab-dropdown",
                            class: { "vab-dropdown-active": !_vm.fold },
                            attrs: { icon: "arrow-up-s-line" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            icon: "el-icon-search",
                            "native-type": "submit",
                            type: "primary"
                          },
                          on: { click: _vm.handleQuery }
                        },
                        [_vm._v(" 查询 ")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { "native-type": "submit" },
                          on: {
                            click: function($event) {
                              return _vm.reset("queryForm")
                            }
                          }
                        },
                        [_vm._v(" 重置 ")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "vab-query-form-left-panel",
            [
              _c(
                "el-button",
                {
                  attrs: {
                    disabled: !_vm.queryForm.idList.length > 0,
                    size: "mini",
                    type: "danger"
                  },
                  on: { click: _vm.deleteData }
                },
                [_vm._v(" 删除 ")]
              ),
              _c("uploadExcel", {
                attrs: {
                  "down-url": "客户映射关系导入模版.xlsx",
                  "upload-aciton": _vm.bt
                }
              }),
              _c(
                "el-button",
                {
                  attrs: {
                    loading: _vm.loadingExPort,
                    size: "mini",
                    type: "primary"
                  },
                  on: { click: _vm.exPort }
                },
                [_vm._v(" 导出 ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.openColumnSettings }
                },
                [_vm._v(" 设置列 ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { height: "calc(100vh - 320px)" } },
        [
          _c(
            "vxe-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading"
                }
              ],
              ref: "tableRef",
              attrs: {
                id: "customerMappingDraftTable",
                border: "",
                "checkbox-config": { trigger: "row", range: true },
                "custom-config": _vm.customConfig,
                data: _vm.list,
                height: "100%",
                "row-config": { isHover: true, isCurrent: true, height: 35 },
                "scroll-y": { enabled: true },
                "show-overflow": ""
              },
              on: {
                "checkbox-all": _vm.setSelectRows,
                "checkbox-change": _vm.setSelectRows
              },
              scopedSlots: _vm._u([
                {
                  key: "empty",
                  fn: function() {
                    return [
                      _c("el-image", {
                        staticClass: "vab-data-empty",
                        attrs: {
                          src: require("@/assets/empty_images/data_empty.png")
                        }
                      })
                    ]
                  },
                  proxy: true
                }
              ])
            },
            [
              _c("vxe-column", {
                attrs: {
                  align: "center",
                  field: "selectOption",
                  fixed: "left",
                  type: "checkbox",
                  width: "55"
                }
              }),
              _c("vxe-column", {
                attrs: {
                  align: "center",
                  fixed: "left",
                  title: "序号",
                  type: "seq",
                  width: "70"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var seq = ref.seq
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              seq +
                                (_vm.queryForm.pageNum - 1) *
                                  _vm.queryForm.pageSize
                            ) +
                            " "
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("vxe-column", {
                attrs: {
                  align: "center",
                  field: "cusProductCnName",
                  "min-width": "140",
                  title: "客户中文品名"
                }
              }),
              _c("vxe-column", {
                attrs: {
                  align: "center",
                  field: "cusProductEnName",
                  "min-width": "140",
                  title: "客户英文品名"
                }
              }),
              _c("vxe-column", {
                attrs: {
                  align: "center",
                  field: "reportCnName",
                  "min-width": "200",
                  title: "申报中文品名"
                }
              }),
              _c("vxe-column", {
                attrs: {
                  align: "center",
                  field: "reportEnName",
                  "min-width": "220",
                  title: "申报英文品名"
                }
              }),
              _c("vxe-column", {
                attrs: {
                  align: "center",
                  field: "hsCode",
                  "min-width": "120",
                  title: "中国海关编码"
                }
              }),
              _c("vxe-column", {
                attrs: {
                  align: "center",
                  field: "reportFactor",
                  "min-width": "140",
                  title: "中国申报要素"
                }
              }),
              _c("vxe-column", {
                attrs: {
                  align: "center",
                  field: "materialCn",
                  "min-width": "140",
                  title: "中文材质"
                }
              }),
              _c("vxe-column", {
                attrs: {
                  align: "center",
                  field: "materialEn",
                  "min-width": "200",
                  title: "英文材质"
                }
              }),
              _c("vxe-column", {
                attrs: {
                  align: "center",
                  field: "useTo",
                  "min-width": "200",
                  title: "用途"
                }
              }),
              _c("vxe-column", {
                attrs: {
                  align: "center",
                  field: "description",
                  "min-width": "200",
                  title: "商品描述"
                }
              }),
              _c("vxe-column", {
                attrs: {
                  align: "center",
                  field: "category",
                  "min-width": "200",
                  title: "大类"
                }
              }),
              _c("vxe-column", {
                attrs: {
                  align: "center",
                  field: "chapter",
                  "min-width": "200",
                  title: "章节"
                }
              }),
              _c("vxe-column", {
                attrs: {
                  align: "center",
                  field: "items",
                  "min-width": "200",
                  title: "商品名称"
                }
              }),
              _c("vxe-column", {
                attrs: {
                  align: "center",
                  field: "regulatoryCondition",
                  "min-width": "200",
                  title: "监管条件"
                }
              }),
              _c("vxe-column", {
                attrs: {
                  align: "center",
                  field: "inspection",
                  "min-width": "200",
                  title: "检验检疫"
                }
              }),
              _c("vxe-column", {
                attrs: {
                  align: "center",
                  field: "statusName",
                  "min-width": "80",
                  title: "状态"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        row.status === 0
                          ? _c(
                              "span",
                              [
                                _c("el-tag", { attrs: { type: "info" } }, [
                                  _vm._v(_vm._s(row.statusName))
                                ])
                              ],
                              1
                            )
                          : _vm._e(),
                        row.status === 1
                          ? _c(
                              "span",
                              [
                                _c("el-tag", { attrs: { type: "info" } }, [
                                  _vm._v(_vm._s(row.statusName))
                                ])
                              ],
                              1
                            )
                          : _vm._e(),
                        row.status === 2
                          ? _c(
                              "span",
                              [
                                _c("el-tag", { attrs: { type: "success" } }, [
                                  _vm._v(_vm._s(row.statusName))
                                ])
                              ],
                              1
                            )
                          : _vm._e()
                      ]
                    }
                  }
                ])
              }),
              _c("vxe-column", {
                attrs: {
                  align: "center",
                  field: "createBy",
                  "min-width": "100",
                  title: "创建人"
                }
              }),
              _c("vxe-column", {
                attrs: {
                  align: "center",
                  field: "dataSourceName",
                  "min-width": "100",
                  title: "数据来源"
                }
              }),
              _c("vxe-column", {
                attrs: {
                  align: "center",
                  field: "createTime",
                  "min-width": "200",
                  title: "创建时间"
                }
              }),
              _c("vxe-column", {
                attrs: {
                  align: "center",
                  field: "transactionUrl",
                  fixed: "right",
                  "min-width": "80",
                  title: "链接"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c(
                          "a",
                          {
                            attrs: {
                              href: row.transactionUrl,
                              target: "_blank"
                            }
                          },
                          [_vm._v(" " + _vm._s(row.transactionUrl) + " ")]
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("vxe-column", {
                attrs: {
                  align: "center",
                  field: "option",
                  fixed: "right",
                  title: "操作",
                  width: "150"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c(
                          "el-button",
                          {
                            staticStyle: { padding: "0" },
                            attrs: { type: "text" },
                            on: {
                              click: function($event) {
                                return _vm.addOrEdit(row)
                              }
                            }
                          },
                          [_vm._v(" 编辑 ")]
                        ),
                        _c(
                          "el-button",
                          {
                            staticStyle: { padding: "0" },
                            attrs: { disabled: !row.pictureUrl, type: "text" },
                            on: {
                              click: function($event) {
                                return _vm.preview(row)
                              }
                            }
                          },
                          [_vm._v(" 图片预览 ")]
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _c("el-pagination", {
        attrs: {
          background: "",
          "current-page": _vm.queryForm.pageNum,
          layout: _vm.layout,
          "page-size": _vm.queryForm.pageSize,
          total: _vm.total
        },
        on: {
          "current-change": _vm.handleCurrentChange,
          "size-change": _vm.handleSizeChange
        }
      }),
      _vm.isDetailsShow
        ? _c(
            "div",
            { staticClass: "posit" },
            [
              _c(
                "span",
                {
                  staticStyle: {
                    position: "absolute",
                    right: "15px",
                    top: "15px",
                    "z-index": "9999",
                    cursor: "pointer",
                    "font-size": "15px",
                    "font-weight": "600"
                  },
                  on: { click: _vm.formSmbiClose }
                },
                [
                  _vm._v(" 返回上一级 "),
                  _c("vab-icon", { attrs: { icon: "arrow-go-back-line" } })
                ],
                1
              ),
              _c("Details", {
                ref: "details",
                attrs: { id: _vm.id, dialog_visible: _vm.isDetailsShow },
                on: { dialogVisibleEvent: _vm.formSmbiClose }
              })
            ],
            1
          )
        : _vm._e(),
      _c("table-edit", {
        ref: "edit",
        attrs: {
          modulelist: _vm.queryList,
          "system-guid": _vm.queryForm.systemGuid
        }
      }),
      _c("Preview", { ref: "preview" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }